import { render, staticRenderFns } from "./SfScrollable.vue?vue&type=template&id=1b81efc6&"
import script from "./SfScrollable.vue?vue&type=script&lang=js&"
export * from "./SfScrollable.vue?vue&type=script&lang=js&"
import style0 from "./SfScrollable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports